<template>
  <div
    class="table-scrollable"
    :class="color ? `color-${color}` : false"
  >
    <table>
      <thead>
        <tr>
          <th
            v-for="(cell, cellIndex) in head"
            :key="cellIndex"
          >
            <span class="table-filter__head">
              {{ cell.content }}
              <button
                v-if="cell.sortable"
                :aria-label="
                  sortColumn === cellIndex && sortDir === 'asc'
                    ? 'Absteigend sortieren'
                    : 'Aufsteigend sortieren'
                "
                class="button button--small button--filter button--square table-filter__sort"
                :class="`button--${color}`"
                @click="handleSort(cellIndex)"
              >
                <svg
                  class="icon button__icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    v-if="sortColumn === cellIndex && sortDir === 'asc'"
                    d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
                  />
                  <path
                    v-else-if="sortColumn === cellIndex && sortDir === 'desc'"
                    d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                  />
                  <path
                    v-else
                    d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
                  />
                </svg>
              </button>
            </span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(row, rowIndex) in body"
          :key="rowIndex"
        >
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            :class="{
              'text-align-center': cell.align === 'center',
              'text-align-right': cell.align === 'right'
            }"
          >
            <a
              v-if="cell.type === 'link'"
              :href="cell.url"
              :target="cell.target"
              v-bind="cell.attrs"
            >
              {{ cell.content }}
            </a>
            <span v-else-if="cell.type === 'date'">
              {{ new Date(cell.content).toLocaleDateString('de-DE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }) }}
            </span>
            <span v-else>
              {{ cell.content }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CTable',

  props: {
    color: {
      type: String,
      default: undefined
    },
    head: {
      type: Array,
      required: true
    },
    body: {
      type: Array,
      required: true
    },
    sortColumn: {
      type: Number,
      default: undefined
    },
    sortDir: {
      type: String,
      default: 'asc'
    }
  },

  methods: {
    handleSort (column) {
      this.$emit('sort', {
        column,
        dir: this.sortDir === 'asc' ? 'desc' : 'asc'
      })
    }
  }
}
</script>
